import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  .secondary-media-control {
    position: relative;
  }
`
